module.exports = __webpack_public_path__ + "static/vid2-3ad56115dcd5d657f13213b3e649a985.mp4";